jQuery( function ( $ ) {

    const $body = $( 'body' );
    const $header_wrap = $( '#header-wrap' );
    const $header = $( '#site-header' );
    const $menu = $( '#menu-wrap' );
    const $toggle = $( '#mobile-menu-toggle' );
    const speed = 300;
    const stylesheet = $( "#theme-main-css" ).get(0).sheet;

    // create focus trap
    const focus_trap = focusTrap.createFocusTrap( $header.get(0), {
        onActivate () {
            $toggle.addClass( 'is-active' );
            $menu.addClass( 'visible' )
            $body.addClass( 'menu-open' );
        },
        onDeactivate () {
            $toggle.removeClass( 'is-active' );
            $body.removeClass( 'menu-open' );
            setTimeout( function () {
                $menu.removeClass( 'visible' );
            }, speed );
        },
        initialFocus: $toggle.get(0),
    });


    function resize () {
        const header_height = $header.outerHeight();
        $header_wrap.css( 'height', header_height );
        $menu.css( 'top', ThemeJS.Media_Queries.is_at_least( 'xl' ) ? 0 : header_height );
        $menu.removeClass( 'mobile-transition-enabled' );
        setTimeout( function () {
            $menu.addClass( 'mobile-transition-enabled' );
        }, 0 );
        if ( ThemeJS.Media_Queries.is_at_least( 'xl' ) ) {
            focus_trap.deactivate()
        }
    }

    // init header pad height and set header to fixed
    resize();
    $header.addClass( 'fixed' );
    // trigger height recalculation on breakpoint change
    $( window ).on( 'breakpoint_changed', resize );

    // toggle mobile menu on hamburger click
    $toggle.click( () => {
        $body.hasClass( 'menu-open' ) ? focus_trap.deactivate() : focus_trap.activate();
    });
    
    // set body padding when menu open
    stylesheet.insertRule( `body.menu-open, body.menu-open #menu-wrap, body.menu-open #site-header { padding-right: ${ ThemeJS.Functions.get_scrollbar_width() }px !important; }`, stylesheet.cssRules.length );

});